/**
 * Marca principal del sitio. Archivo estático: `public/img/hitchhikers.svg` (favicon / manifest en `public/`).
 */
export const BRAND_MARK_URL = `${import.meta.env.BASE_URL}img/hitchhikers.svg`
